<template>
    <div class="AutoRenew">
        <div class="title re_relative re_flex_center re_font_18" :class="{ 'is-pad-top': userStore.isPadTop }">
            <van-icon @click="goBack()" class="icon" name="arrow-left" size="22" />
            <span>自动续费服务协议</span>
        </div>
        <p>欢迎您使用由中道新职坊科技发展有限公司（以下称“中道”或“中道公司”）提供的自动续费服务（以下简称“自动续费服务”或“本服务”）。为了保障用户的权益，请在使用本服务之前，详细阅读此服务协议（以下简称“本协议”）。
        </p>
        <p>除非您已阅读并同意本协议所有内容，否则您无权使用本服务。如您购买或使用本服务，即表示已经与中道公司达成协议，并自愿接受本协议的所有内容。</p>
        <p>如果您未满18周岁，请在法定监护人陪同下或经过法定监护人同意后再使用本服务；未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可，本协议对您及您的法定监护人产生法律约束力。</p>
        <p>由于互联网的行业特性，本协议及相关服务规则如由于业务发展需要进行修订的，中道公司将在开水壶平台进行公示。您可前往查阅最新版协议条款。在修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用自动续费服务。您继续使用本服务，将被视为已接受了修改后的协议。
        </p>
        <p class="section-title">第一条 服务说明</p>
        <p>1.1本服务是在您开通单身泡泡会员、青春泡泡会员等现有及未来新增/调整付费服务的前提下，基于您对自动续费的需求，避免因您未及时续费而中断服务而推出的服务。自动续费分为连续包月、连续包季和连续包年三种订阅服务期类型，对应的计费周期费用分为包月费用、包季费用和包年费用。
        </p>
        <p>1.2如您通过苹果公司（本协议中“苹果公司”指Apple lnc及其关联公司）AppleID开通本服务，且在下一个订服务到期前24小时前未主动取消本自动续费服务的，则果公司将在每个订阅期即将到期前24小时，从您开通本自动续费服务时绑定的Apple ID账户（以下统称“账户”）余额中自动代扣下一个订阅期服务费，从而延长该订阅期对应的服务有效期。</p>
        <p>1.3如您通过安卓（Android）产品开通本服务，且在订阅服务期内未主动取消本自动续费服务，则第三方支付渠道将自付费服务到期前一天开始，从您开通本自动续费服务时绑定的第三方支付账户（包括但不限于支付宝账户、微信钱包账户）等账户余额中自动代扣下一个订阅服务期费用，从而延长该订阅期对应的付费服务有效期。
        </p>
        <p>1.4您理解并同意，因部分渠道（如运营商话费支付）由运营商或者支付渠道根据实际情况自行决定扣费周期，前述自动续费服务的扣款时间以各渠道实际扣款时间为准。</p>
        <p>1.5
            请您关注上述各类账户及可扣款余额状况，如因账户问题或余额不足导致续费失败而引发的风险或导致的损失将由您自行承担（如相应权益终止、会员身份受到影响等）。如您未主动明确选择取消本服务，将视为您同意在订阅服务期满后的一定期限内进行不时的扣款尝试（具体以各支付渠道的扣款规则为准）。中道公司将在您账户余额恢复充足时/后，继续为您提供自动续费服务，一旦扣款成功，中道公司将继续为您提供付费权益。
        </p>
        <p class="section-title">第二条 自动续费使用规则</p>
        <p>2.1根据相关法律规定，为便于您知悉自动续费情况，中道公司在下一个订阅期扣款前3日通知您，第三方支付渠道也可能向您发送扣款前的提醒通知，请您予以关注。</p>
        <p>2.2 请您特别注意，基于自动续费服务的特点，自动代扣将按照本协议1.2、1.3、1.4条约定方式和时间完成。如果您未在代扣之前明确取消自动续费服务，中道公司将根据您的委托向相关主体发出下一个订阅期的代扣指令，原则上对基于该指令扣除的费用将不予退还。
        </p>
        <p>2.3 如在扣费过程出现差错，中道公司和您应密切配合查明原因，各自承担已方过错造成的损失；若因双方各自存在不均等过错造成的损失，由双方按过错的程度承担相应责任；双方共负责任的，由双方均摊责任。</p>
        <p>2.4中道公司对您开通自动续费服务暂不收取任何额外费用，但中道公司有权根据业务发展需要决定是否对自动续费服务进行额外收费，并在相关页面向您进行公示。</p>
        <p>2.5 中道公司向您提供的本服务仅限于您在开水壶平台使用，任何以恶意破解等非法手段规避续费而使用付费服务的，均构成对本协议的违反。由此引起的一切法律后果由行为人负责，中道公司将依法追究行为人的法律责任。</p>
        <p class="section-title">第三条 服务中止、中断及终止</p>
        <p>3.1 除非中道公司另有通知、公告，本服务将长期有效。本协议自您选择接受或使用本服务后生效，直至您终止本服务或注销付费服务资格时终止。</p>
        <p>3.2 出现下列情况之一的，中道公司有权立即终止向您提供服务，且无须为此向您或任何第三方承担责任:</p>
        <p>（1）经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者中道公司根据自身的判断，认为您的行为涉嫌违反本协议内容，或涉嫌违反法律法规的规定的；</p>
        <p>（2）您的行为干扰了开水壶平台任何部分或功能的正常运行；</p>
        <p>（3）中道公司认为向您提供本服务存在重大风险的。</p>
        <p>3.3如您希望取消自动续费，您可以在下一个订阅期结束前的24小时通过以下方式取消自动续费:</p>
        <p>（1）ApplelD 购买</p>
        <p>iOS12及以上系统:打开苹果iOS设备“App Store”-->点击右上角苹果账户头像-->进入“账户”-->点击“订阅”-->选择网易云音乐，取消订阅即可；</p>
        <p>iOS12以下系统:打开苹果手机“设置”-->进入“iTunesStore 与 App Store”-->点击“Apple lD”,选择"查看Apple
            lD”,进入“账户设置“页面，点击“订阅”，选择网易云音乐，取消订阅即可。</p>
        <p>（2）安卓端购买进入“开水壶”-->进入单身泡泡/青春泡泡-->“点击会员”-->“点击会员状态”，取消订阅自动续费即可。</p>
        <p>您也可直接在微信、支付宝等第三方支付客户端内取消自动扣款设置，具体操作方式以各产品实际功能为准。</p>
        <p>3.4 本服务取消成功后，不影响您已成功扣费且生效的付费服务，已生效的付费服务期满后不再自动续费。您在选择终止本服务前已经委托中道公司自动续费扣款的指令仍然有效，中道公司对于基于该指令扣除的费用不予退还，由您自行承担相关责任。
        </p>
        <p class="section-title">第四条 其他</p>
        <p>4.1本协议的解释及争议解决均应适用中华人民共和国法律，并且排除一切冲突法规定的适用。如就本协议的签订、行等发生任何争议的，双方应尽量友好协商解决，协商不成时，任何一方均可向被告住所地享有管辖权的人民法院提起诉讼。
        </p>
        <p>4.2 中道公司不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响中道公司在将来行使该权利。</p>
        <p>4.3 如果用户对本条款内容有任何疑问，请发送邮件至我们的客服邮箱：ppdevelop@163.com。</p>

    </div>
</template>
<script setup>
import { onMounted } from 'vue';
import { useUserStore } from '../../stores/user';
const userStore = useUserStore();
// 返回
const goBack = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
        appJsImp.finish()
    }
    if (isiOS) {
        window.webkit.messageHandlers.AppModel.postMessage('finish')
    } 
}
onMounted(() => {
    // 设置标题兼容ios高度
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isiOS){
        userStore.setIsPadTop(true)
    }
})
</script>
<style scoped>
.title {
        padding: 28px 0 18px 0;
        width: 100%;
        font-weight: 600;
        
    }
.icon {
    position: absolute;
    left: 16px;
    bottom: 18px;
    margin-left: -16px;
    padding: 0 24px 0 0;
}
.right {
    position: absolute;
    right: 0px;
    bottom: 18px;
    color: #FFFFFF;
    height: 24px;
    background: #FF4EBD;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.right img {
    width: 15px;
    height: 14px;
    margin-right: 4px;
}
.is-pad-top {
    padding-top: 36px;
}
.AutoRenew {
    font-family: "Microsoft YaHei", "SimHei", sans-serif;
    line-height: 1.6;
    max-width: 100%;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
}

h1 {
    text-align: center;
    color: #333;
}

p {
    text-indent: 2em;
    margin-bottom: 15px;
    color: #555;
}

.section-title {
    font-weight: bold;
    color: #000;
    margin-top: 25px;
}
</style>